<template>
    <div class="programa-page">
        <Menu-component />
        <div class="container">
            <section class="background">
                <div class="content-wrapper">
                    <div class="section">
                        <div class="title-section">
                            <h2>O Programa</h2>
                        </div>
                        <div class="content">
                            <div class="column-01">
                                <p>Instrumento de planejamento executivo e dinâmico, o Programa de Segurança Hídrica reúne os investimentos estratégicos recomendados pelo PNSH para minimização dos riscos associados à escassez de água e controle de cheias.</p>
                            </div>
                            <div class="column-02">
                                <h3>Componentes do Programa</h3>
                            </div>
                        </div>
                        <div class="box-zul">
                            <div class="collapse">
                                <div class="main-collpase">
                                    <VueFaqAccordion :items="itensCollapse" />
                                </div>
                            </div>
                            <div class="box-zul-02">
                                <img src="@/assets/info-03.png" alt="Programa de Segurança Hidrica">
                            </div>
                        </div>
                    </div>
                    <div class="navegacao">
                        <div class="arrow-down" @click="next">
                            <img src="@/assets/arrow-down.svg" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="background">
                <div class="content-wrapper">
                    <div class="section">
                        <div class="texto-section">
                            <p>O caminho da segurança hídrica está ancorado em uma trajetória de evolução da necessidade de investimentos que considera diferentes estágios de desenvolvimento das intervenções. O roteiro se inicia por estudos, passa pelos projetos, até se materializar em obras, seguindo os seguintes passos:</p>
                            <h3>Caminho da Segurança Hídrica</h3>
                        </div>
                        <div class="box-zul-dois">
                            <div class="column-01">
                                <img src="@/assets/info-04.png" alt="">
                            </div>
                            <div class="column-02">
                                <VueFaqAccordion :items="itensCriseHidrica" />
                            </div>
                        </div>
                    </div>
                    <div class="navegacao">
                        <div class="arrow-down" @click="next">
                            <img src="@/assets/arrow-down.svg" />
                        </div>
                        <div class="arrow-up" @click="prev">
                            <img src="@/assets/arrow-up.svg" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="background">
                <div class="content-wrapper">
                    <div class="section">
                        <div class="section-03">
                                                    <div class="texto-section-03">
                            <h3>Benefícios do PSH</h3>
                            <p>Os benefícios do PSH podem ser analisados a partir do efeito das intervenções recomendadas na redução dos riscos hídricos. No caso da dimensão humana, para 54,8 milhões de habitantes em maior risco, existe um roteiro para o suprimento dos deficits. Cerca de 18,2 milhões de habitantes são diretamente beneficiados por obras recomendadas, em estágio mais avançado no caminho da segurança hídrica. Os demais também contam com intervenções no PSH, cujas obras potenciais dependem da realização e da conclusão dos estudos recomendados. No caso da dimensão econômica, o efeito das intervenções recomendadas no PSH gera redução de R$ 69,8 bilhões/ano do valor em risco das atividades agropecuárias e industriais.</p>
                        </div>
                        <div class="box">
                            <div class="column-01">
                                <h3>Dimensão Humana do ISH - 2035 (sem PNSH)</h3>
                                <div class="content-grafico">
                                    <div>
                                        <img src="@/assets/info-07.png" alt="">
                                    </div>
                                    <div>
                                         <p>Grau de segurança Hídrica</p>
                                        <ul class="nivel-grafico">
                                                <li>Mínimo</li>
                                                <li>Baixo</li>
                                                <li>Médio</li>
                                                <li>Alto</li>
                                                <li>Máximo</li>
                                        </ul>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104">
                                            <g fill="none" fill-rule="evenodd">
                                                <path fill="#4EB3F3" d="M51.983 51.88L.569 45.59C3.707 19.59 25.793 0 51.983 0v51.88z"/>
                                                <path fill="#A6FF73" d="M51.983 51.88L21.569 93.841C6.121 82.958-1.966 64.335.569 45.59l51.414 6.288z"/>
                                                <path fill="#FFFF4D" d="M51.983 51.88v51.878c-10.983.121-21.604-3.386-30.414-9.916l30.414-41.963z"/>
                                                <path fill="#FFA64C" d="M51.983 51.88l50.207 12.576c-5.552 23.218-26.431 39.423-50.207 39.302V51.88z"/>
                                                <path fill="#F23319" d="M51.983 51.88V0c28.603 0 51.776 23.219 51.776 51.88 0 4.232-.483 8.464-1.57 12.576L51.984 51.879z"/>
                                                <circle cx="51.5" cy="51.5" r="32.5" fill="#FFF"/>
                                                <text fill="#FFF" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="78" y="27">29%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="70" y="86">21%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="32" y="92">10%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="6" y="70">17%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="16" y="23">23%</tspan>
                                                </text>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="column-02">
                                <h3>Dimensão Humana do ISH - 2035 (com PNSH)</h3>
                                <div class="content-grafico">
                                    <div>
                                        <img src="@/assets/info-07_1.png" alt="">
                                    </div>
                                    <div>
                                        <p>Grau de segurança Hídrica</p>
                                        <ul class="nivel-grafico">
                                                <li>Mínimo</li>
                                                <li>Baixo</li>
                                                <li>Médio</li>
                                                <li>Alto</li>
                                                <li>Máximo</li>
                                        </ul>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="103" height="104" viewBox="0 0 103 104">
                                            <g fill="none" fill-rule="evenodd" transform="translate(0 -3)">
                                                <path fill="#4EB3F3" d="M51.505 55.255L.96 65.1c-5.402-27.974 12.727-54.987 40.7-60.39 3.242-.6 6.483-.96 9.845-.96v51.505z"/>
                                                <path fill="#A6FF73" d="M51.505 55.255l28.093 43.1C55.707 113.844 23.771 107.12 8.284 83.23 4.682 77.706 2.161 71.463.96 64.979l50.545-9.724z"/>
                                                <path fill="#FFFF4D" d="M51.505 55.255l32.415-39.98c22.091 17.89 25.453 50.305 7.564 72.396-3.362 4.202-7.444 7.924-12.006 10.805l-27.973-43.22z"/>
                                                <path fill="#FFA64C" d="M51.505 55.255L54.146 3.87c10.925.36 21.37 4.443 29.654 11.406l-32.295 39.98z"/>
                                                <path fill="#F23319" d="M51.505 55.255V3.75c1.2 0 1.56 0 2.641.12l-2.641 51.385z"/>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="84.04" y="55.177">30%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="27.613" y="94.593">31%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="8.203" y="35.364">28%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="58.828" y="16.958">10%</tspan>
                                                </text>
                                                <text fill="#000" font-family="Rubik-Regular, Rubik" font-size="8">
                                                    <tspan x="45.421" y="13.558">1%</tspan>
                                                </text>
                                                <circle cx="51.505" cy="55.255" r="32.416" fill="#FFF"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>De maneira geral, cada real (R$ 1,00) investido para aumento da segurança hídrica gera cerca de quinze reais (R$ 14,56) em benefícios a partir
                            das intervenções do PSH.</p>
                            <br>
                           <router-link tag="button" class="btn-green" to="/intervencao">As Intervenções</router-link>
                        </div>
                    </div>
                    <div class="navegacao">
                        <div class="arrow-up" @click="prev">
                            <img src="@/assets/arrow-up.svg" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
import Menu from '@/components/Menu'

export default {
  components: {
    VueFaqAccordion,
    'Menu-component': Menu
  },


  data () {
    return {

      itensCollapse: [
        {
          title: 'Componente Estudos e Projetos',
          value: 'Inclui os investimentos para a elaboração dos projetos das obras recomendadas e dos estudos complementares necessários à confirmação de obras potenciais.'
        },
        {
          title: 'Componente Obras',
          value: 'Abrange os investimentos referentes à execução física das obras recomendadas. '
        },
        {
          title: 'Componente Institucional',
          value: 'Inclui os investimentos estimados para operação e manutenção das obras recomendadas, exceto energia elétrica.'
        }
      ],
      itensCriseHidrica: [
        {
          title: 'Estudo de Detalhamento de Planos de Desenvolvimento Regional',
          value: 'Dirigido às intervenções cujo propósito é o desenvolvimento regional, deve promover uma análise do conjunto das intervenções de forma integrada e ter foco na efetividade das demandas a serem atendidas e nas vulnerabilidades e aptidões das bacias abrangidas.'
        },
        {
          title: 'Estudos de alternativas para aproveitamento de recursos hídricos em áreas complexas ou em áreas de baixo grau de segurança hídrica',
          value: 'Compreendem o estudo e a escolha de alternativas para intervenções localizadas em regiões em que existem riscos associados à oferta de água, mas sem identificação de soluções.'
        },
        {
          title: 'Estudos de Viabilidade Técnico-Econômica e Ambiental (EVTEA)',
          value: 'Recomendados para as intervenções que precisam de avaliação de alternativas ou de otimização de propostas anteriores que carecem de adequações.'
        },
        {
          title: 'Anteprojeto de engenharia, projeto básico ou projeto executivo',
          value: 'Para as intervenções que, após a análise integrada, foram habilitadas e constituem investimentos recomendados, porém se encontram em diferentes estágios de implementação.'
        },
         {
          title: 'Execução de obras',
          value: 'Para intervenções que, após a análise integrada, foram habilitadas e estão com obras em andamento.'
        }
      ],
      eventoScroll: null,
      delta: null,
      ticking: false,
      scrollSensitivitySetting: 20,
      currentSlideNumber: 0,
      totalSlideNumber: null,
      slideDurationSetting: 300
    }
  },

  mounted () {
    this.totalSlideNumber = document.querySelectorAll('.background').length;
    this.previousItem()
     this.mousewhellevent();
  },

   destroyed () {
      window.removeEventListener('wheel', this.onMouseWheel);
   },

  methods: {

    mousewhellevent () {
      let screen = window.screen.width
      if (screen <= 1200) {
        return false
      }

       window.addEventListener('wheel', this.onMouseWheel);
    },

    onMouseWheel (evt) {
        this.eventoScroll = evt
        this.parallaxScroll(this.eventoScroll)
    },

    parallaxScroll (evt) {
      let isFirefox = (/Firefox/i.test(navigator.userAgent));
      let isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));

      if (isFirefox) {
        this.delta = evt.detail * (-120);
        console.log('aqui no firefox')
      } else if (isIe) {
        this.delta = -evt.deltaY;
      } else {
        this.delta = evt.wheelDelta;
      }

      if (this.ticking !== true) {
        if (this.delta <= -this.scrollSensitivitySetting) {
          this.ticking = true;

          if (this.currentSlideNumber !== this.totalSlideNumber - 1) {
            this.currentSlideNumber++;
            this.nextItem();
          }
          this.slideDurationTimeout(this.slideDurationSetting);
        }
        if (this.delta >= this.scrollSensitivitySetting) {
          this.ticking = true;
          if (this.currentSlideNumber !== 0) {
            this.currentSlideNumber--;
          }
          this.previousItem();
          this.slideDurationTimeout(this.slideDurationSetting);
        }
      }
    },

    nextItem () {
       var $previousSlide = document.querySelectorAll('.background')[this.currentSlideNumber - 1];
       $previousSlide.classList.remove('up-scroll')
       $previousSlide.classList.add('down-scroll');
    },

    previousItem () {
      var $currentSlide = document.querySelectorAll('.background')[this.currentSlideNumber];
      $currentSlide.classList.remove('down-scroll')
      $currentSlide.classList.add('up-scroll');
    },

    next () {
        this.currentSlideNumber++;
        this.nextItem()
    },

    prev () {
        this.currentSlideNumber--;
        this.previousItem()
    },

    slideDurationTimeout (slideDuration) {
      setTimeout(() => {
        this.ticking = false;
      }, slideDuration);
    }
  }
}
</script>


<style lang="scss" scoped>

.container {
    padding-top: 70px;
    width: 1234px;
    @include media_tablet() {
        padding-top: 50px;
        width: 100%;
    }
}


.programa-page {
    position: relative;
    &::after {
        content: '';
        background-image: url(../assets/assets-esquerda.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0px;
        height: 60vh;
        width: 10vh;
        @include media_tablet() {
          display: none;
        }
    }

    &::before {
        content: '';
        background-image: url(../assets/assets-direita.svg);
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        top: 189px;
        right: 0px;
        height: 995px;
        width: 21vh;
        @include media_tablet() {
          display: none;
        }
    }
}

.content {
  display: flex;

  @include media_tablet() {
    flex-direction: column;
    margin-bottom: 110px;
  }

  .title-section {
    @media (max-height:  900px) and (min-width: 1200px) {
        padding-left: 75px;
        margin-bottom: 20px;
    }
  }

  .column-01 {
    padding-left: 210px;
    width: 500px;

    @include media_tablet() {
      padding-left: 20px;
      width: 100%;
    }
    @media (max-height:  900px) and (min-width: 1200px) {
        padding-left: 76px;
        width: 500px;
    }

    p {
      font-size: 14px;
      color: #565656;
      line-height: 22px;
      @media (max-height:  900px) and (min-width: 1200px) {
        font-size: 13px;
        color: #565656;
        line-height: 17px;
       }
    }
  }

  .column-02 {
    h3 {
      padding-left: 73px;
      margin-top: 32px;

      @include media_tablet() {
        padding-left: 20px;
        margin-bottom: 0;
        margin-top: 18px;
      }
      @media (max-height:  900px) and (min-width: 1200px) {
        padding-left: 73px;
        margin-top: 10px;
        font-size: 16px;
      }
    }
  }
}

.box-zul {
  display: flex;
  background-color: #3994d0;
  margin-top: 37px;



  @include media_tablet() {
    width: 100%;
    height: auto;
    flex-direction: column-reverse;
  }

   @media (max-height:  900px) and (min-width: 1200px) {
    margin-top: 20px;
   }

  .collapse {
    width: 525px;

    @include media_tablet() {
      width: 100%;
    }

    .main-collpase {
      width: 414px;
      margin-top: 57px;
      margin-left: 86px;
      background-color: #fff;
      border-radius: 35px;

      @include media_tablet() {
        border-radius: 30px;
        width: 80%;
        margin: 0 auto 36px auto;
        margin-top: 15px;
        background-color: #fff;
        border-radius: 35px;
      }
      @media (max-height:  900px) and (min-width: 1200px) {
        margin: 30px 0 0 90px;
        width: 70%;
      }

    }
  }
}


  .box-zul-02 {
    width: 711px;

    @include media_tablet() {
      width: 90%;
      margin: 0 auto;
    }

    img {
      max-width: 80%;
      margin-top: -84px;

      @include media_tablet() {
        display: block;
        margin: -42px auto 20px auto;
      }

      @media (max-height:  900px) and (min-width: 1200px) {
        max-width: 55%;
        margin-top: -40px;
      }


    }
  }

.texto-section {
  margin-bottom: 20px;
  width: 542px;

  @include media_tablet() {
    margin-bottom: 20px;
    width: 100%;
    margin-top: 33px;
  }

  p {
    color: #565656;
    font-size: 14px;
    line-height: 24px;
    padding-left: 104px;
    @include media_tablet() {
      padding-left: 20px;
    }

    @media (max-height:  900px) and (min-width: 1200px) {
        font-size: 13px;
        line-height: 20px;
        padding-left: 50px;
    }

  }

  h3 {
    margin-top: 30px;
    padding-left: 104px;
    @include media_tablet() {
      padding-left: 20px;
    }
    @media (max-height:  900px) and (min-width: 1200px)   {
        margin-top: 15px;
        padding-left: 104px;
        font-size: 16px;
    }
  }
}

.box-zul-dois {
  display: flex;
  background-color: #3994d0;
  @include media_tablet() {
    flex-direction: column;
  }
  .column-01 {
    width: 707px;

    @include media_tablet() {
      width: 90%;
      margin: 0 auto;
    }

    img {
      max-width: 85%;
      margin-top: 0px;
     @include media_tablet() {
       display: block;
       margin: 0 auto;
    }
    @media (max-height:  900px) and (min-width: 1200px)   {
        max-width: 60%;
        margin-top: -20px;
        margin-left: 100px;
    }
    }
  }
  .column-02 {
    padding: 0px 55px 15px 27px;
    width: 527px;
    @include media_tablet() {
      width: 100%;
      padding: 0 22px 36px 22px;
    }
  }
}

button {
  cursor: pointer;
  margin: 15px 0 0 auto;
  &::after {
    content: "";
    position: absolute;
    right: 62px;
    top: 17px;
    background-repeat: no-repeat;
    background-image: url(../assets/seta-direita-branca.svg);
    width: 9px;
    height: 14px;

    @include media_tablet() {
      top: 22px;
      right: 35px;
    }
  }

  @include media_tablet() {
    margin: 15px 0 0 0;
    width: 100%;
    border-radius: 30px 30px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.section-03 {
    margin: 0 auto;
    width: 1025px;
    @include media_tablet() {
        width: 100%;
        padding: 0 23px;
    }
    .texto-section-03 {
            width: 1025px;
            @include media_tablet() {
               width: 100%;
               padding: 20px 23px;
            }
            h3 {
                margin-bottom: 20px;
                @media (max-height:  900px) and (min-width: 1200px) {
                    font-size: 16px;
                }
            }

            p {
                line-height: 22px;
                margin-bottom: 2vh;
                @media (max-height:  900px) and (min-width: 1200px) {
                    font-size: 13px;
                }
            }
    }
    .box {
        display: flex;
        margin: 0 auto;
        width: 1025px;
        margin-bottom: 30px;
        @include media_tablet() {
            flex-direction: column;
            width: 100%;
        }
        @media (max-height:  900px) and (min-width: 1200px) {
            margin-bottom: 10px;
        }

        .column-01 {
            margin-right: 55px;

            @include media_tablet() {
                margin: 0px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center
            }

            h3 {
                font-size: 14px;
                margin-bottom: 20px;
                @media (max-height:  900px) and (min-width: 1200px) {
                    font-size: 12px;
                }
            }


            .content-grafico {
                display: flex;
                @include media_tablet() {
                    flex-direction: column;
                }


                div {

                    p {
                        line-height: 24px;
                        padding-left: 25px;
                        @media (max-height:  900px) and (min-width: 1200px) {
                            font-size: 13px;
                        }
                    }
                }

                img {
                    max-width: 100%;
                    margin-right: 25px;
                    width: 347px;
                    height: 347px;
                    @include media_tablet() {
                        margin: 0px;
                        width: 100%;
                    }
                }

                ul {
                    padding-left: 25px;
                    margin-top: 10px;
                    @include media_tablet() {
                        float: left;
                    }
                    li {
                        color: #565656;
                        font-size: 14px;
                        position: relative;
                        margin-bottom: 15px;
                        padding-left: 40px;
                        @media (max-height:  900px) and (min-width: 1200px) {
                            font-size: 12px;
                        }

                        &:nth-child(1) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #f23319;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(2) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #ffa64c;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(3) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #ffff4d;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(4) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #a6ff73;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(5) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #4eb3f3;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                }

                svg {
                    padding-left: 25px;
                    width: 140px;
                    height: 140px;
                    @include media_tablet() {
                        width: 140px;
                        height: 140px;
                    }
                }
            }

        }
        .column-02 {
            @include media_tablet() {
                margin: 0px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center
            }

             h3 {
                font-size: 14px;
                margin-bottom: 20px;
                @media (max-height:  900px) and (min-width: 1200px) {
                    font-size: 12px;
                }
            }


            .content-grafico {
                display: flex;
                @include media_tablet() {
                    flex-direction: column;
                }

                div {

                    p {
                        line-height: 24px;
                        padding-left: 25px;
                        @media (max-height:  900px) and (min-width: 1200px) {
                            font-size: 13px;
                        }
                    }
                }

                img {
                    max-width: 100%;
                    margin-right: 25px;
                    width: 347px;
                    height: 347px;
                    @include media_tablet() {
                        margin: 0px;
                        width: 100%;
                    }

                }

                ul {
                    padding-left: 25px;
                    margin-top: 10px;
                    @include media_tablet() {
                       float: left;
                    }
                    li {
                        color: #565656;
                        font-size: 14px;
                        position: relative;
                        margin-bottom: 15px;
                        padding-left: 40px;
                        @media (max-height:  900px) and (min-width: 1200px) {
                            font-size: 12px;
                        }

                        &:nth-child(1) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #f23319;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(2) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #ffa64c;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(3) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #ffff4d;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(4) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #a6ff73;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                        &:nth-child(5) {
                            &::after{
                                content: '';
                                position: absolute;
                                top: -4px;
                                left: 0;
                                background-color: #4eb3f3;
                                background-position: top left;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                }

                svg {
                    padding-left: 25px;
                    width: 140px;
                    height: 140px;
                     @include media_tablet() {
                        width: 140px;
                        height: 140px;
                    }
                }
            }
        }
    }
}

p {
@media (max-height:  900px) and (min-width: 1200px) {
    font-size: 13px;
   }
}







.navegacao {
    position: absolute;
    bottom: 22vh;
}

</style>
